import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinLogo, XLogo, TelegramLogo } from '@phosphor-icons/react';
import { PUBLIC_ROUTES } from '../../constants/routes';
import { getMainSiteUrl, isOnDocsSubdomain, isOnHelpSubdomain } from '../../utils/navigation';
import './HelpApiFooter.css';

/**
 * HelpApiFooter Component
 * Custom footer for Help Center and API Documentation pages
 * Includes logo, 3 links (Terms, Privacy Policy, Support), and 3 social icons
 */
const HelpApiFooter = () => {
  const isOnDocs = isOnDocsSubdomain();
  const isOnHelp = isOnHelpSubdomain();
  const mainSiteUrl = getMainSiteUrl();
  
  // Use absolute URLs when on docs or help subdomain, relative Link when on main site
  const TermsLink = (isOnDocs || isOnHelp) ? (
    <a href={mainSiteUrl + PUBLIC_ROUTES.TERMS}>Terms</a>
  ) : (
    <Link to={PUBLIC_ROUTES.TERMS}>Terms</Link>
  );
  
  const PrivacyLink = (isOnDocs || isOnHelp) ? (
    <a href={mainSiteUrl + PUBLIC_ROUTES.PRIVACY}>Privacy Policy</a>
  ) : (
    <Link to={PUBLIC_ROUTES.PRIVACY}>Privacy Policy</Link>
  );
  
  return (
    <footer className="help-api-footer">
      <div className="help-api-footer-container">
        <div className="help-api-footer-logo">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fwesplit-logo.png?alt=media&token=4f50d17a-de63-455e-bb13-9a6950784159" 
            alt="WeSplit logo" 
          />
        </div>
        <div className="help-api-footer-links">
          {TermsLink}
          {PrivacyLink}
          <a href="https://t.me/+v-e8orBns-llNThk" target="_blank" rel="noopener noreferrer">Support</a>
        </div>
        <div className="help-api-footer-socials">
          <a href="https://x.com/wesplit_io" className="help-api-footer-social" target="_blank" rel="noreferrer">
            <XLogo weight="regular" size={22} />
          </a>
          <a href="https://t.me/+v-e8orBns-llNThk" className="help-api-footer-social" target="_blank" rel="noreferrer">
            <TelegramLogo weight="regular" size={22} />
          </a>
          <a href="https://www.linkedin.com/company/wesplit-io/" className="help-api-footer-social" target="_blank" rel="noreferrer">
            <LinkedinLogo weight="regular" size={22} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default HelpApiFooter;
